import { API_URL } from "./api.base";
import { AxiosInstance } from "./axios.core";

import {
  ListResponseModel,
  ListRuquestModel
} from "./models";

export const addAndroidApp = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/app/add`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const updateAndroidApp = (id: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/app/patch/${id}`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const getApps = (
  params: ListRuquestModel
): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/app/list`, { params });
};

export const getAndroidApp = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/app/${id}`);
};

export const getAppHistoryList = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/app/${id}/history`);
};


export const deleteAndroidApp = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/app/delete/${id}`);
};

export const getAllApps = (
  params: any
): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/app/list/all`, { params });
};
export const getAndroidDeviceApps = (
  params: any
): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/android/apps/available`, { params });
};

export const pushInstallApp = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/${id}/push`, { ...params });
};
export const iosApplicationStrategy = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/ios/${id}/settings`, { ...params });
};
export const pushIosInstallApp = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/ios/${id}/push`, { ...params });
};

export const appStrategy = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/${id}/settings`, { ...params });
};

export const getAppIntallDetail = (
  appId: string,
  params: ListRuquestModel
): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/app/${appId}/devices`, { params });
};
export const getIosAppIntallDetail = (
  packageName: string,
  params: ListRuquestModel
): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/app/${packageName}/iosdevices`, { params });
};
export const getInstallStates = (
  packageName: string,
  params: ListRuquestModel
): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/app/${packageName}/installstates`, { params });
};
export const retryAppStore = (adamId: string, deviceId: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/${adamId}/devices/${deviceId}/install`);
};
export const retryEnterprise = (appId: string, deviceId: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/enterprises/${appId}/devices/${deviceId}/install`);
};
export const updateAppStatus = (id: string, status: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/${id}?status=${status}`);
};
export const abmDepKey = (abmId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/abm/dep/${abmId}/key`);
};
export const abmDepToken = (abmId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.post(`${API_URL}/abm/dep/${abmId}/token`, params, { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
};
export const abmDepInfo = (params: any = {}): Promise<any> => {
  // return AxiosInstance.get(`${API_URL}/abm/dep/info`);
  return AxiosInstance.get(`${API_URL}/abm/dep`, { params });
};
export const abmDepId = (): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/abm/dep`);
};
export const abmDepDelete = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/abm/dep/${id}`);
};
export const abmVppUploadToken = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.post(`${API_URL}/abm/vpp/upload/token`, params, { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
};
export const getAbmVppToken = (params: any = {}): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/abm/vpp`, { params });
};
export const deleteAbmVppToken = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/abm/vpp/${id}`);
};
export const getIosApps = (
  params: any
): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/abm/vpp/apps`, { params });
};
export const getAllIosApps = (
  params: any
): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/ios/apps/${params.deviceType}/all`);
};

export const getAllMacApps = (): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/mac/apps/all`);
};

export const getMacNativeApps = (): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/mac/nativeApps`);
};

export const getAllIosAppStoreApps = (
  params: any
): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/ios/app/appStore/all`, { params });
};
export const vppAppIdBing = (appleid: string, id: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/abm/vpp/appleid?appleid=${appleid}&id=${id}`);
};
export const refushApp = (): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/abm/vpp/assets/sync`);
};

export const appStoreGroup = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/${id}/appstore/group`, { ...params });
};
export const getAppStoreGroup = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/app/${id}/appstore/group`);
};
export const companyStoreGroup = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/${id}/group`, { ...params });
};
export const getCompanyStoreGroup = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/app/${id}/group`);
};
export const getAppType = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/app/categories`);
};
export const getAndroidAppType = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/android/appType`);
};
export const updateAndroidAppGetInfo = (_params: any, onUploadProgress: (progressEvent: any) => void): Promise<any> => {

  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/app/package`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      onUploadProgress: onUploadProgress
    },
  );
};
export const getAppStoreSearchList = (params:any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/app/AppStore/search`, { params });
};
export const addAppStoreByAppId = (appId:number,country:any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/app/AppStore/Add/${appId}?country=${country}`);
};
export const updateMacAppGetInfo = (_params: any, onUploadProgress: (progressEvent: any) => void): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/app/package/mac`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      onUploadProgress: onUploadProgress
    },
  );
};
